// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Lj-z","carouselContainer":"Mj-z","carouselContent":"Nj-z"};